module.exports = __webpack_public_path__ + "img/info_circle_outline.565dcfa4.svg";